import React, { useState,useEffect } from 'react'
import './switch.scss'
const Switch = ({title, info, defaultValue, style, onChange }) => {
    let [checked, setChecked] = useState(false)
    useEffect (()=>{
        setChecked(defaultValue)
    },[defaultValue])
    return (
        <div className='switch-block' style={style} >
            <div className='left'>
                <p>{title}</p>
                <p className='text'>{info}</p>
            </div>
            <label className={"switch round"}>
                <input type="checkbox"
                    checked={checked}
                    onChange={(e) => {
                        setChecked(!checked)
                        onChange(!checked)
                    }}
                />
                <span className={"slider round"} />
            </label>
        </div>
    )
}

export default Switch